import { useTypedSelector } from 'hooks'
import { useQuery, UseQueryResult } from 'react-query'
import { AxiosResponse } from 'axios'
import { User } from '@fable/types'
import { get } from '@fable/api'
import { useStats } from '../ctx/stats'

export const useStatsUserQuery = () => {
  const { isVerifying } = useTypedSelector(({ auth }) => auth)
  const setAuthUser = useStats((s) => s.setAuthUser)

  const query: UseQueryResult<AxiosResponse<User>> = useQuery(
    ['stats-user'],
    async () => await get('/settings/profile/'),
    {
      enabled: !isVerifying,
      refetchOnMount: true,
      refetchOnWindowFocus: true,
      staleTime: 0,
      cacheTime: 0,
      onSuccess: ({ data }) => setAuthUser(data),
    }
  )

  return query
}
